import * as types from '../mutation-types'

export default {
	namespaced: true,

	state: {
		stores: [],
		permissionsForStores: [],
	},

	actions: {
		fetchAll({ commit }, { fromDate, toDate, country, name, storeNo, status, archiveStatus, page, perPage }) {
			return axios.get('/stores', {
				params: { fromDate, toDate, country, name, storeNo, status, archiveStatus, page, perPage }
			}).then(({ data }) => {
				commit(types.STORE_STORES, data);
				return data;
			})
		},
		fetchById({ commit }, { id }) {
			return axios.get(`/stores/${id}`).then(({ data }) => {
				return data;
			})
		},

		update ({ commit }, { id, name, storeNo, country, invoiceMessage, notes, defaultLanguage, defaultCurrencyId, phone, address, logo, originName, anotherName, facebookQrCodeLink, instagramQrCodeLink }) {
			const formData = new FormData();
			if (id) formData.append('id', id);
			if (name) formData.append('name', name);
			if (storeNo) formData.append('storeNo', storeNo);
			if (country) formData.append('country', country);
			if (invoiceMessage) formData.append('gratitudeMessage', invoiceMessage);
			if (notes) formData.append('notes', notes);
			if (defaultLanguage) formData.append('defaultLanguage', defaultLanguage);
			if (defaultCurrencyId) formData.append('defaultCurrencyId', defaultCurrencyId);
			if (phone) formData.append('phone', phone);
			if (address) formData.append('address', address);
			if (logo) formData.append('logo', logo);
			if (originName) formData.append('originName', originName);
			if (anotherName) formData.append('anotherName', anotherName);
			if (facebookQrCodeLink) formData.append('facebookQrCodeLink', facebookQrCodeLink);
			if (instagramQrCodeLink) formData.append('instagramQrCodeLink', instagramQrCodeLink);
			return axios.put(`/stores/${id}`, formData)	
		},

		create({ commit }, { name, storeNo, country, invoiceMessage, notes, defaultLanguage, defaultCurrencyId, initialSaleInvoiceNumber, originName, anotherName, facebookQrCodeLink, instagramQrCodeLink, phone }) {
			return axios.post('/stores', {
				name, storeNo, country, gratitudeMessage: invoiceMessage, notes, defaultLanguage, defaultCurrencyId, initialSaleInvoiceNumber, originName, anotherName, facebookQrCodeLink, instagramQrCodeLink, phone
			}).then(({ data }) => { 
				return data
			})
		},
		archive({ commit }, { id }) {
			return axios.put(`/stores/${id}/Archive`, { id })
		},

		retrieve({ commit }, { id }) {
			return axios.put(`/stores/${id}/Retrieve`, { id })
		},

		StoreAccessPermissions({ commit }, { storeId }) {
			return axios.get(`Users/Permissions/${storeId}`).then(({ data }) => {
				commit(types.STORE_PERMISSIONS_FOR_STORES, data);
				return data
			})
		},

		reset({ commit }) {
			commit(types.RESET);
		}
	},

	mutations: {
		[types.STORE_STORES](state, stores) {
			state.stores = stores;
		},
		[types.RESET](state) {
			state.stores = [];
		},
		[types.STORE_PERMISSIONS_FOR_STORES](state, permissionsForStores) {
			state.permissionsForStores = permissionsForStores;
		},
	},

	getters: {
		getStoreById: state => id => state.stores.find(c => c.id === id)
	}
}